/**
 * Script principal du thème (menu mobile géré par header-mobile.js)
 */

(function($) {
    'use strict';

    // Scripts spécifiques au thème (hors header mobile)
    $(document).ready(function() {
        // Réservé aux interactions futures
    });

})(jQuery);
